/* global axios */
import ApiClient from '../../ApiClient';

class KontaVoiceApiClient extends ApiClient {
  constructor() {
    super('konta_voice', { accountScoped: true });
  }

  getToken(inboxId) {
    if (!inboxId) return Promise.reject(new Error('Inbox ID is required'));
    return axios
      .get(`${this.baseUrl()}/inboxes/${inboxId}/konta_conference/token`)
      .then(r => r.data);
  }

  joinConference({ conversationId, inboxId, callSid }) {
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/konta_conference`, {
        conversation_id: conversationId,
        call_sid: callSid,
      })
      .then(r => r.data);
  }

  releaseConference({ conversationId, inboxId, callSid }) {
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/konta_conference/release`, {
        conversation_id: conversationId,
        call_sid: callSid,
      })
      .then(r => r.data);
  }

  leaveConference(inboxId, conversationId) {
    return axios
      .delete(`${this.baseUrl()}/inboxes/${inboxId}/konta_conference`, {
        params: { conversation_id: conversationId },
      })
      .then(r => r.data);
  }

  initiateCall(contactId, inboxId) {
    return axios
      .post(`${this.baseUrl()}/contacts/${contactId}/konta_call`, {
        inbox_id: inboxId,
      })
      .then(r => r.data);
  }
}

export default new KontaVoiceApiClient();
